import { faBarChart, faCheckCircle, faFile, faPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Process2 = () => {
  const steps = [
    {
      number: "01",
      title: " Assessment",
      description: "Complete our quick assessment and get personalized visa recommendations",
      icon: faBarChart,
      gradient: "from-blue-500 to-cyan-500"
    },
    {
      number: "02",
      title: "Document Preparation",
      description: "We guide you through all document requirements and verification",
      icon: faFile,
      gradient: "from-purple-500 to-blue-500"
    },
    {
      number: "03",
      title: "Application Submission",
      description: "We handle the entire submission process with authorities",
      icon: faPlane,
      gradient: "from-green-500 to-cyan-500"
    },
    {
      number: "04",
      title: "Visa Approval",
      description: "Receive your visa with travel preparation guidance",
      icon: faCheckCircle,
      gradient: "from-orange-500 to-red-500"
    }
  ];

  return (
    <section id="process" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16" data-aos="zoom-in">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Simple 4-Step Process
          </h2>
          <p className="text-xl text-gray-600">
            From assessment to approval - we make it easy
          </p>
        </div>

        {/* Vertical Timeline */}
        <div className="relative">
          {/* Center Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-blue-200 to-cyan-200 transform -translate-x-1/2"></div>
          
          {/* Steps */}
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div 
                key={index}
                className={`flex flex-col lg:flex-row items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Step Card */}
                <div className={`lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                  <div data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'} className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
                    <div className="flex items-center mb-4">
                      <div className={`w-12 h-12 rounded-xl bg-gradient-to-r ${step.gradient} flex items-center justify-center text-white text-lg font-bold mr-4`}>
                        {step.number}
                      </div>
                      <div className="text-2xl"><FontAwesomeIcon icon={step.icon}/></div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {step.title}
                    </h3>
                    <p className="text-gray-600">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Center Dot */}
                <div className="hidden lg:flex absolute left-1/2 transform -translate-x-1/2">
                  <div className={`w-6 h-6 rounded-full bg-gradient-to-r ${step.gradient} border-4 border-white shadow-lg`}></div>
                </div>

                {/* Empty Space */}
                <div className="lg:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transition duration-300">
            Start Your Journey
          </button>
        </div>
      </div>
    </section>
  );
};

export default Process2;